module.exports = __webpack_public_path__ + "static/media/playCircle.0a154713.svg";